import { Header } from "components/Header/Header";
import { NameInput } from "components/NameInput/NameInput";
import { CustomModal } from "components/WaitingRoom/Modals/CustomModal";
import { CustomModalps } from "components/WaitingRoom/Modals/CustomModalps";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShuffle,
  faPlus,
  faRobot,
  faMinus,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import {
  Box,
  Icon,
  Container,
  Block,
  Section,
  Button,
  Heading,
  Form,
} from "react-bulma-components";
import { addBot } from "socket/events/addBot";
import { leaveRoom } from "socket/events/leaveRoom";
import { getPlayerAvatar } from "utils/getPlayerAvatar";
import { randomizeAvatar } from "socket/events/randomizeAvatar";
import { removeBot } from "socket/events/removeBot";
import { startGame } from "socket/events/startGame";
import { store } from "store/store";
import { useI18n } from "i18n/I18nProvider";
import { getPlayerDisplayName } from "utils/getPlayerDisplayName";
import { updateBotDifficulty } from "socket/events/updateBotDifficulty";
import { BotDifficulty } from "backend/src/common/types/roomState";
import styles from "./styles.module.scss";

const BOT_DIFFICULTIES: BotDifficulty[] = ["easy", "medium", "hard"];

export const WaitingRoom = observer(() => {
  const { locale, t } = useI18n();
  const room = store.currentRoom;
  useEffect(() => {
    window.location.hash = room;
  }, [room]);
  const [modalpsActive, setModalpsActive] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const isHost = store.players[0] === store.currentPlayer;
  const currentPlayer = store.currentPlayer;
  if (!currentPlayer) return null;

  const copyCode = () => {
    toast(t("waiting.linkCopied"));
    navigator.clipboard.writeText(
      "https://playevolution.me/#" + store.currentRoom,
    );
  };

  return (
    <div>
      <Header
        title={store.currentRoom}
        onBack={() => leaveRoom(store.currentRoom)}
      />
      <hr />

      <Section>
        <Container>
          <Box>
            <NameInput />

            <Form.Field>
              <Form.Label>{t("waiting.avatar")}</Form.Label>
              <Container
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  className={styles.image}
                  src={getPlayerAvatar(currentPlayer)}
                />
                <Form.Control>
                  <Button
                    color="primary"
                    onClick={() => {
                      randomizeAvatar();
                    }}
                  >
                    <Icon>
                      <FontAwesomeIcon icon={faShuffle} />
                    </Icon>
                  </Button>
                </Form.Control>
              </Container>
            </Form.Field>

            <div className={styles.container_settings}>
              <Button.Group align="center">
                <Button onClick={() => setModalActive(true)}>
                  {t("waiting.gameSettings")}
                </Button>
                <Button onClick={() => setModalpsActive(true)}>
                  {t("waiting.personalSettings")}
                </Button>
              </Button.Group>
              <CustomModal active={modalActive} setActive={setModalActive} />
              <CustomModalps
                activeps={modalpsActive}
                setActiveps={setModalpsActive}
              />
              {isHost && (
                <Button
                  onClick={startGame}
                  color="primary"
                  renderAs="span"
                  className={styles.button_start}
                >
                  {t("waiting.startGame")}
                </Button>
              )}
            </div>
          </Box>
        </Container>
      </Section>
      <Container>
        <Box>
          <Block>
            <Heading subtitle>{t("waiting.players")}</Heading>
            {store.players.map((player) => (
              <li
                key={player.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 12,
                  marginBottom: 8,
                }}
              >
                <span>
                  {player.isBot && "🤖 "}
                  {getPlayerDisplayName(locale, player.meta.name)}{" "}
                  {player === store.currentPlayer && t("waiting.youSuffix")}
                </span>
                {isHost && player.isBot && (
                  <Form.Select
                    size="small"
                    value={player.botDifficulty || "medium"}
                    onChange={(event) => {
                      updateBotDifficulty(
                        player.id,
                        event.target.value as BotDifficulty,
                      );
                    }}
                  >
                    {BOT_DIFFICULTIES.map((difficulty) => (
                      <option key={difficulty} value={difficulty}>
                        {difficulty}
                      </option>
                    ))}
                  </Form.Select>
                )}
              </li>
            ))}
          </Block>
          <Block
            style={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            {isHost && (
              <>
                <div className={styles.margin}>
                  <Icon
                    color="primary"
                    onClick={copyCode}
                    className={styles.plus_minus}
                  >
                    <FontAwesomeIcon
                      className="fas fa-home fa-xl"
                      icon={faShare}
                    />
                  </Icon>
                </div>
                <div className={styles.margin}>
                  <Icon
                    color="primary"
                    onClick={() => {
                      removeBot();
                    }}
                    className={styles.plus_minus}
                  >
                    <FontAwesomeIcon
                      className="fas fa-home fa-xl"
                      icon={faMinus}
                    />
                  </Icon>
                </div>
                <div className={styles.margin}>
                  <Icon color="primary">
                    <FontAwesomeIcon
                      className="fas fa-home fa-xl"
                      icon={faRobot}
                    />
                  </Icon>
                </div>
                <div className={styles.margin}>
                  <Icon
                    color="primary"
                    onClick={() => {
                      addBot();
                    }}
                    className={styles.plus_minus}
                  >
                    <FontAwesomeIcon
                      className="fas fa-home fa-xl"
                      icon={faPlus}
                    />
                  </Icon>
                </div>
              </>
            )}
          </Block>
        </Box>
      </Container>

      <hr />
    </div>
  );
});
